// Listens for variant changes and creates link to prefill current options in create app
if (!customElements.get("capp-link")) {
  customElements.define(
    "capp-link",
    class CappLink extends HTMLElement {
      constructor() {
        super();
      }

      //closest() and querySelector() need the element in the live tree,
      //which a constructor cannot assume
      connectedCallback() {
        try {
          var product_el = this.closest(".product");

          if (!product_el) return;

          this.colourIndex = JSON.parse(product_el.dataset.baseColorIndex);

          this.baseUrl = this.dataset.base;

          this.button = this.querySelector(".extra-atc a");

          this.productData = JSON.parse(
            this.querySelector("[data-type='productData']").innerHTML,
          );
        } catch (e) {
          console.error(e);
          return;
        }

        if (
          !this.productData ||
          !this.baseUrl ||
          this.baseUrl.length == 0 ||
          this.colourIndex < 0 ||
          !this.button
        )
          return;

        //document.body outlives this element, so tie the listener to its life
        this.listeners?.abort();
        this.listeners = new AbortController();

        document.body.addEventListener(
          "variantChange",
          this.handleVariantChange.bind(this),
          { signal: this.listeners.signal },
        );

        this.generateCAppUrl(this.productData.initialVariant);
      }

      disconnectedCallback() {
        this.listeners?.abort();
      }

      handleVariantChange(e) {
        var current_variant = e.detail.currentVariant;
        this.generateCAppUrl(current_variant);
      }

      generateCAppUrl(current_variant) {
        if (!current_variant) return;

        // doesnt include collection info
        var current_variant_title = current_variant.title;

        var matched_products = this.matchCappProducts(current_variant_title);

        var search_params = new URLSearchParams();

        switch (this.productData.type) {
          case "direct":
            search_params.set(
              `tone`,
              current_variant.options[this.colourIndex],
            );

            search_params.set("base", "direct_collection");

            var search_params = this.generateCharmsArray(
              matched_products,
              search_params,
            );

            break;

          default:
            break;
        }

        this.setButtonUrl(search_params);
      }

      setButtonUrl(search_params) {
        this.button.href = this.baseUrl + "?" + search_params.toString();
      }

      matchCappProducts(current_variant_title) {
        var matched_capp_products = [];

        //shopify joins option values with " / ", so compare whole values —
        //a substring test matches "S" inside "SILVER" and "L" inside "GOLD"
        var title_options = current_variant_title
          .split("/")
          .map((value) => value.trim().toLowerCase());

        this.productData.products.forEach((prod_data) => {
          var matched_item_variant_index = prod_data.variants.findIndex(
            (variant) => {
              for (let i = 0; i < variant.options.length; i++) {
                const option = variant.options[i];
                const prod_option = prod_data.options[i];

                if (
                  prod_option &&
                  !title_options.includes(option.toLowerCase())
                ) {
                  //has a non-combined listings options and doesnt match (any)
                  return false;
                }
              }
              return true;
            },
          );

          if (matched_item_variant_index >= 0) {
            matched_capp_products.push({
              collection: prod_data.collection,
              product_id: prod_data.product_id,
              variant_index: matched_item_variant_index,
            });
          }
        });

        return matched_capp_products;
      }

      generateCharmsArray(matched_items, search_params) {
        matched_items.forEach((item, i) => {
          search_params.set(`charms[${i}][coll-id]`, item.collection);
          search_params.set(`charms[${i}][prod-id]`, item.product_id);
          search_params.set(`charms[${i}][var-id]`, item.variant_index);
        });

        return search_params;
      }
    },
  );
}
